<template>
  <div
    v-if="swatches"
    class="product-card-swatches"
  >
    <span
      v-for="(color) in swatches.slice(0, 3)"
      :key="`swatch-${color}`"
      class="product-card-swatches__swatch"
      :style="{ 'background-color': color.colorHexCode}"
    />

    <span
      v-if="swatches.length - 3 > 0"
      class="product-card-swatches__color-count text-body-xs"
      v-text="`+${swatches.length - 3}`"
    />
  </div>
</template>

<script>

/**
 * Vue: Product card swatches (product-card-swatches)
 * -----------------------------------------------------------------------------
 * Global product card swatches template.
 *
 * @param {Object} product - Product object.
 *
 */
export default {
  name: 'ProductCardSwatches',

  props: {
    product: {
      type: [Object, Boolean],
      default: () => ({}),
    },
  },

  data() {
    return {
      global: true,
    }
  },

  computed: {

    /**
     * Get product swatch values.
     */
    swatches() {
      let swatchHexes = this.product.swatchHexes
      const productMeta = this.product.meta

      if (!swatchHexes && productMeta) {
        swatchHexes = productMeta.product?.wts_color_hex_code_json
      }

      if (!swatchHexes) {
        return false
      }

      return JSON.parse(swatchHexes)
    },
  },
}
</script>
